import {IAirBridge} from './IAirBridge';

export class AirBridgeImpl implements IAirBridge {
    constructor(private window: Window) {
    }
    public evoke(payload: string): void {
        if (!this.window.AirBridge) {
            throw new Error('No AirBridge');
        }
        this.window.AirBridge.evoke(payload);
    }
}
